var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"btn-wrapper mt-1 clearfix"},_vm._l((_vm.btns),function(item,n){return _c('div',{key:n,staticClass:"btn",class:{'active': _vm.value === item.value},on:{"click":function($event){$event.stopPropagation();return _vm.change(item)}}},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }